/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { css } from 'styled-components';

import { UiBreakpoint } from '../../utils/constants';

const LayoutStyles = css`
	.layout-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 100%;
		max-width: 616px;
		min-width: 320px;
		margin: 0 auto;
		min-height: 100vh;
		padding: 64px 0 16px;

		main {
			display: flex;
			margin-bottom: 40px;

			section {
				width: 100%;
			}
		}
	}

	@media (max-width: ${UiBreakpoint}px) {
		.layout-container {
			min-height: 100vh;
			max-width: none;
			padding: 24px;
			margin-bottom: 32px;
		}
	}

	@media (max-width: 320px) {
		.layout-container {
			padding: 24px 20px;
			margin-bottom: 20px;
		}
	}
`;

export default LayoutStyles;
